import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate,useParams } from 'react-router-dom';

const EnrichAdmin = () => {
    const navigate = useNavigate();
    const {storeId, token} = useParams();

    useEffect(() => {
        const fethcMenuList = async () => {
            sessionStorage.setItem('jwtToken', token);
            navigate(`/qr_order/adminMenuList`);
        }
        if (token){
            fethcMenuList();
        
        }
       
    }, [token]);
   


}
export default EnrichAdmin;